import { Suspense, useEffect } from 'react';

import { OLoader } from '@src/shared';

import { useAuthenticationContext } from '@src/contexts';
import { isWebView } from '@src/helpers';

const WrappedComponent = ({ Component }: { Component: React.ComponentType }) => {
  const { isAuthenticated, isLoading, handleRedirect } = useAuthenticationContext();

  useEffect(() => {
    if (!isAuthenticated && !isLoading) {
      handleRedirect();
    }
  }, [handleRedirect, isAuthenticated, isLoading]);

  if (isLoading && !isWebView()) return <OLoader />;

  return !isAuthenticated ? null : <Component />;
};

const WithAuth = (Component: React.ComponentType) => (
  <Suspense fallback={<OLoader />}>
    <WrappedComponent Component={Component} />
  </Suspense>
);

export default WithAuth;
